module.exports = __webpack_public_path__ + "img/right-from-bracket-solid.a39e0c6f.svg";